/* eslint-disable */
import { Routes, Route, Navigate } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import LoginPage from '../Pages/Login'
import LoginOtp from '../Pages/LoginOtp'
import ResetPassword from '../Pages/ResetPassword'
import PostLoginContainer from '../Pages/PostLoginContainer'
import SignUp from '../Pages/SignUp'
import ActivateAccountOTP from '../Pages/ActivateAccountOtp'
import LoginWithPassword from '../Pages/LoginWithPassword'
import LoginContainer from '../Pages/LoginContainer'
import LoginWithOTP from '../Pages/LoginWithOTP'
import LoadingSkeleton from '../Components/LoadingSkeleton'
import { TaxFiling } from '../Pages/Tax/TaxFiling'
import RetirementCalculator from '../Pages/Calculator/RetirementCalculatorNew'
import AdminRetirementCalculator from '../Pages/ActionPlan/Calculator/RetirementCalculatorNew'
import { DematUser, PrivateRoute } from './PrivateRoute'

import MutualFunds from '../Pages/MutualFunds/MutualFunds'
import MFInvestments from '../Pages/MutualFunds/MFInvestments'
import MFDetails from '../Pages/MutualFunds/MFDetails'
import MFPlaceOrder from '../Pages/MutualFunds/MFPlaceOrder'
import MFOrders from '../Pages/MutualFunds/MFOrders'
import MFPayment from '../Pages/MutualFunds/MFPayment'

import MFRedeem from '../Pages/MutualFunds/MFRedeem'
import BankPaymentResponse from '../Pages/MutualFunds/BankPaymentResponse'
import UserSource from '../Pages/UserSource'
import MFBasketPlaceOrder from '../Pages/MutualFundsBaskets/MFBasketPlaceOrder'
import MFBasketOneTimePayment from '../Pages/MutualFundsBaskets/MFBasketOneTimePayment'
import MFBasketBankPayment from '../Pages/MutualFundsBaskets/MFBasketBankPayment'
import MFsSIPs from '../Pages/MutualFunds/MFsSIPs'
import NewUser from '../Pages/FirstIdeas/NewUser'
import Returns from '../Pages/FirstIdeas/Returns'
import Questionaire from '../Pages/FirstIdeas/Questionaire'
import ActionPlan from '../Pages/ActionPlan/ActionPlan'
import Index from '../Pages/ActionPlan'
import AddPlan from '../Pages/ActionPlan/AddPlan'
import ActionNotification from '../Pages/ActionPlan/ActionNotification'
import UserActionPlan from '../Pages/FirstIdeas/UserActionPlan'

import GeneralSavingNew from '../Pages/Calculator/GeneralSavingNew'
import ActionOneTimePayment from '../Pages/FirstIdeas/ActionOneTimePayment'
import ActionPlanPaymentStatus from '../Pages/FirstIdeas/ActionPlanPaymentStatus'
import MFBasketRedeem from '../Pages/MutualFundsBaskets/MFBasketRedeem'
import FirstUserIdea from '../Pages/ActionPlan/FirstUserIdea'
import KycUsers from '../Pages/ActionPlan/KycUsers'
import UserChats from '../Pages/ActionPlan/UserChats'
import UserHoldings from '../Pages/ActionPlan/UserHoldings'
import OneTimeMandate from '../Pages/ActionPlan/OneTimeMandate'
import InvestMoreOneTime from '../Pages/ActionPlan/InvestMoreOneTime'
import Redeem from '../Pages/ActionPlan/Redeem'
import AdminPlaceOrder from '../Pages/ActionPlan/AdminPlaceOrder'
import InvestMoreSIP from '../Pages/ActionPlan/InvestMoreSIP'
import KycLanding from '../Pages/KycLanding'
import MFMandatePage from '../Pages/MutualFundsBaskets/MFMandatePage'
import FrontendLogs from '../Pages/ActionPlan/FrontendLogs'
import RefreshData from '../Pages/ActionPlan/RefreshData'
import ChequeOrders from '../Pages/ActionPlan/ChequeOrders'
import MFUpiPayment from '../Pages/MutualFunds/MFUpiPayment'
import Homepage from '../Pages/FirstIdeas/Homepage'
import SIPsOrders from '../Pages/ActionPlan/SIPsOrders'
import UpdateSipsMandate from '../Pages/MutualFundsBaskets/UpdateSipsMandate'

export default function RoutesConfig() {
  const FirstIdeasSection = lazy(() => import('../Pages/FirstIdeasSection'))

  const ChildPlan = lazy(() => import('../Pages/Calculator/EducationCalculator'))

  const WeddingPlan = lazy(() => import('../Pages/Calculator/WeddingCalculator'))
  const PurchasePlan = lazy(() => import('../Pages/Calculator/PurchaseCalculator'))
  const VehiclePlan = lazy(() => import('../Pages/Calculator/VehicleCalculator'))
  const VacationCalculator = lazy(() => import('../Pages/Calculator/VacationCalculator'))
  const PassionCalculator = lazy(() => import('../Pages/Calculator/PassionCalculator'))
  const JewelleryCalculator = lazy(() => import('../Pages/Calculator/JewelleryCalculator'))
  const EmergencyPlan = lazy(() => import('../Pages/Calculator/EmergencyCalculator'))
  const HomePurchaseCalculator = lazy(() => import('../Pages/Calculator/HomePurchaseCalculator'))

  const Profile = lazy(() => import('../Pages/Profile/ProfileScreen'))

  const ReferralNewScreen = lazy(() => import('../Pages/ReferralNewScreen'))

  const Insurance = lazy(() => import('../Pages/Insurance'))

  const SupportPortal = lazy(() => import('../Pages/SupportPortal/SupportPortal'))

  // ADMIN
  const AdminChildPlan = lazy(() => import('../Pages/ActionPlan/Calculator/EducationCalculator'))
  const AdminWeddingPlan = lazy(() => import('../Pages/ActionPlan/Calculator/WeddingCalculator'))
  const AdminPurchasePlan = lazy(() => import('../Pages/ActionPlan/Calculator/PurchaseCalculator'))
  const AdminVehiclePlan = lazy(() => import('../Pages/ActionPlan/Calculator/VehicleCalculator'))
  const AdminVacationCalculator = lazy(() =>
    import('../Pages/ActionPlan/Calculator/VacationCalculator'),
  )
  const AdminPassionCalculator = lazy(() =>
    import('../Pages/ActionPlan/Calculator/PassionCalculator'),
  )
  const AdminJewelleryCalculator = lazy(() =>
    import('../Pages/ActionPlan/Calculator/JewelleryCalculator'),
  )
  const AdminEmergencyPlan = lazy(() =>
    import('../Pages/ActionPlan/Calculator/EmergencyCalculator'),
  )
  const AdminHomePurchaseCalculator = lazy(() =>
    import('../Pages/ActionPlan/Calculator/HomePurchaseCalculator'),
  )

  const AdminGeneralSavingCalculator = lazy(() =>
    import('../Pages/ActionPlan/Calculator/GeneralSavingCalculator'),
  )

  return (
    <Routes>
      <Route path='/' element={<LoginContainer />}>
        <Route index element={<Navigate to='/login' />} />
        <Route path='/login' element={<LoginPage />} />
        <Route path='/otp' element={<LoginOtp />} />
        <Route path='/sign-up' element={<SignUp />} />
        <Route path='/activate-account-otp' element={<ActivateAccountOTP />} />
        <Route path='/password' element={<LoginWithPassword />} />
        <Route path='/otp-login' element={<LoginWithOTP />} />
        <Route path='/reset-password' element={<ResetPassword />} />
        <Route path='/user-source' element={<UserSource />} />
      </Route>

      <Route
        path='/dashboard'
        element={
          <PrivateRoute>
            <PostLoginContainer />
          </PrivateRoute>
        }
      >
        <Route index element={<Homepage />} />
        <Route path='start-kyc' element={<KycLanding />} />
        <Route path='mutual-funds/investments' element={<MFInvestments />} />
        <Route path='mutual-funds/orders' element={<MFOrders />} />
        <Route path='mutual-funds/sips' element={<MFsSIPs />} />

        <Route
          path='mutual-funds'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <MutualFunds />
            </Suspense>
          }
        />

        <Route path='mutual-funds/details' element={<MFDetails />} />
        <Route path='mutual-funds/place-order' element={<MFPlaceOrder />} />
        <Route path='mutual-funds/redeem/place-order' element={<MFRedeem />} />
        <Route path='mutual-funds/order-payment' element={<MFPayment />} />
        <Route path='mutual-funds/payment-request' element={<MFUpiPayment />} />
        <Route path='mutual-funds/order-payment/status' element={<BankPaymentResponse />} />

        <Route
          path='support'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <SupportPortal />
            </Suspense>
          }
        />
        <Route
          path='firstideas'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <FirstIdeasSection />
            </Suspense>
          }
        />

        <Route
          path='educationplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <ChildPlan />
            </Suspense>
          }
        />

        <Route path='place-order' element={<MFBasketPlaceOrder />} />
        <Route path='one-time-payment' element={<MFBasketOneTimePayment />} />
        <Route path='one-time-payment/status' element={<MFBasketBankPayment />} />
        <Route path='basket/redeem/place-order' element={<MFBasketRedeem />} />

        <Route
          path='retirementplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <RetirementCalculator />
            </Suspense>
          }
        />
        <Route
          path='purchaseplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <PurchasePlan />
            </Suspense>
          }
        />
        <Route
          path='vehicleplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <VehiclePlan />
            </Suspense>
          }
        />
        <Route
          path='weddingplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <WeddingPlan />
            </Suspense>
          }
        />
        <Route
          path='emergencyplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <EmergencyPlan />
            </Suspense>
          }
        />
        <Route
          path='vacationplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <VacationCalculator />
            </Suspense>
          }
        />

        <Route
          path='generalsavingplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <GeneralSavingNew />
            </Suspense>
          }
        />

        <Route
          path='passionplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <PassionCalculator />
            </Suspense>
          }
        />
        <Route
          path='jewelleryplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <JewelleryCalculator />
            </Suspense>
          }
        />
        <Route
          path='homepurchase'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <HomePurchaseCalculator />
            </Suspense>
          }
        />

        <Route
          path='profile'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <DematUser>
                <Profile />
              </DematUser>
            </Suspense>
          }
        />

        <Route
          path='refer'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <ReferralNewScreen />
            </Suspense>
          }
        />
        <Route
          path='insurance'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <Insurance />
            </Suspense>
          }
        />
        <Route
          path='tax-filing'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <TaxFiling />
            </Suspense>
          }
        />

        <Route path='newUser' element={<NewUser />} />

        <Route path='returns' element={<Returns />} />
        <Route path='firstTime/questionnaire' element={<Questionaire />} />

        <Route path='firstTime/actionPlanUser' element={<UserActionPlan />} />
        <Route path='mutual-funds/mandate' element={<MFMandatePage />} />
        <Route path='mutual-funds/update-sips' element={<UpdateSipsMandate />} />
        <Route path='actionplan/one-time-payment' element={<ActionOneTimePayment />} />
        <Route path='actionplan/one-time-payment/status' element={<ActionPlanPaymentStatus />} />
      </Route>

      <Route path='*' element={<Navigate replace to='/dashboard' />} />

      <Route
        path='6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin'
        element={<Index />}
      >
        <Route
          index
          element={
            <Navigate
              to='/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/actionPlan'
              replace
            />
          }
        />
        <Route path='actionPlan' element={<ActionPlan />} />
        <Route path='frontend-logs' element={<FrontendLogs />} />
        <Route path='refresh-data' element={<RefreshData />} />
        <Route path='cheque-orders' element={<ChequeOrders />} />
        <Route path='sips-orders' element={<SIPsOrders />} />
        <Route path='addPlan' element={<AddPlan />} />
        <Route path='addPlan/placeOrder' element={<AdminPlaceOrder />} />
        <Route path='firstUserIdeas' element={<FirstUserIdea />} />
        <Route path='kyc-users' element={<KycUsers />} />
        <Route path='userChats' element={<UserChats />} />
        <Route path='userHoldings' element={<UserHoldings />} />
        <Route path='oneTimeThroughMandate' element={<OneTimeMandate />} />
        <Route path='basket/investmore' element={<InvestMoreOneTime />} />
        <Route path='basket/add-sip' element={<InvestMoreSIP />} />
        <Route path='basket/redeem' element={<Redeem />} />

        {/* <Route path='userBasketHoldings' element={<UserBasketHoldings />} />
        <Route path='userBasketOrderHistory' element={<UserBasketOrderHistory />} />
        <Route path='userIndividualHoldings' element={<UserIndividualHoldings />} /> */}
        <Route path='notification' element={<ActionNotification />} />
        <Route
          path='educationplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminChildPlan />
            </Suspense>
          }
        />
        <Route
          path='retirementplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminRetirementCalculator />
            </Suspense>
          }
        />
        <Route
          path='purchaseplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminPurchasePlan />
            </Suspense>
          }
        />
        <Route
          path='vehicleplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminVehiclePlan />
            </Suspense>
          }
        />
        <Route
          path='weddingplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminWeddingPlan />
            </Suspense>
          }
        />
        <Route
          path='emergencyplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminEmergencyPlan />
            </Suspense>
          }
        />
        <Route
          path='vacationplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminVacationCalculator />
            </Suspense>
          }
        />
        <Route
          path='passionplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminPassionCalculator />
            </Suspense>
          }
        />
        <Route
          path='jewelleryplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminJewelleryCalculator />
            </Suspense>
          }
        />
        <Route
          path='homepurchaseplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminHomePurchaseCalculator />
            </Suspense>
          }
        />
        <Route
          path='generalsavingplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminGeneralSavingCalculator />
            </Suspense>
          }
        />
        <Route
          path='*'
          element={
            <Navigate
              replace
              to='/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/actionPlan'
            />
          }
        />
      </Route>
    </Routes>
  )
}
